import React, { Component } from 'react';
import { Button, Col, ControlLabel, Modal, Row } from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment';
import { connect } from 'react-redux';
import {
    createManualLocation,
    getError,
    getLocationCreateIsPending,
    silentFetchRun,
} from '../../duck';
import { bindActionCreators } from 'redux';
import FieldGroup from '../../../../components/FieldGroup';
import { actions } from 'react-redux-toastr';
import SmallLoader from '../../../../components/SmallLoader';

class ManualLocationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            runId: props.runId,
            timestamp: moment(),
            longitude: this.props.lng,
            latitude: this.props.lat,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isPending && !nextProps.isRejected) {
            this.props.onClose();
        }
    }

    handleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({
            [name]: value,
        });
    };

    handleDateChange = newTimeStamp => {
        this.setState({
            timestamp: newTimeStamp,
        });
    };

    handleCreateManualLocation = () => {
        const { toastr } = this.props;
        this.props
            .createManualLocation(this.state)
            /* TODO: This is a temporary solution because the server side events for an updated route
             are not yet implemented. This needs to be removed in favor of a call after the
             server sent that the route is updated. */
            .then(() => {
                return toastr.add({
                    id: 'pending_man_location', // If not provided we will add one.
                    type: 'info',
                    title: 'Adding location...',
                    position: 'top-right', // This will override the global props position.
                    attention: true, // This will add a shadow like the confirm method.
                    options: {},
                });
            })
            .then(() => {
                setTimeout(() => {
                    this.props.fetchGpsLocations('pending_man_location');
                }, 100);
            });
    };

    render() {
        let { onClose, isPending } = this.props;
        return (
            <Modal show={true} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Manual Location</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isPending && (
                        <div className="text-center">
                            <SmallLoader />
                        </div>
                    )}
                    {!isPending && (
                        <div>
                            <FieldGroup
                                id="longitude"
                                name="longitude"
                                type="number"
                                value={this.state.longitude}
                                onChange={this.handleChange}
                                label="Longitude"
                                horizontal
                            />
                            <FieldGroup
                                id="latitude"
                                name="latitude"
                                type="number"
                                value={this.state.latitude}
                                onChange={this.handleChange}
                                label="Latitude"
                                horizontal
                            />
                            <Row style={{ marginBottom: 10 }}>
                                <Col componentClass={ControlLabel} sm={4}>
                                    Timestamp
                                </Col>
                                <Col sm={8}>
                                    <Datetime
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat="HH:mm"
                                        inputProps={{ maxLength: 255 }}
                                        value={this.state.timestamp}
                                        onChange={this.handleDateChange}
                                    />
                                </Col>
                            </Row>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="success"
                        disabled={isPending}
                        onClick={isPending ? null : this.handleCreateManualLocation}
                    >
                        Save
                    </Button>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="default"
                        disabled={isPending}
                        onClick={isPending ? null : onClose}
                    >
                        Dismiss
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    isPending: getLocationCreateIsPending(state),
    isRejected: getError(state),
});

const mapDispatchToProps = dispatch => ({
    createManualLocation: bindActionCreators(createManualLocation, dispatch),
    toastr: bindActionCreators(actions, dispatch),
    loadRun: bindActionCreators(silentFetchRun, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManualLocationModal);
